import {DeepEquals} from "js-vextensions";
import {observer_mgl} from "mobx-graphlink";
import React, {useState} from "react";
import {Button, CheckBox, Column, Row, Spinner, Text, TextInput} from "react-vcomponents";
import {GetLiveSession_Reactive} from "../../../../Engine/LiveSessionManagement.js";
import {SequenceItem} from "../../../../Server/DB/engineConfigs/@TriggerSet.js";
import {TriggerSet_Activator} from "../../../../Server/DB/engineConfigs/@TriggerSet_Activator.js";
import {CanvasOverlay_OnDoubleClick} from "../../../Engine/Journey/Overlays/CanvasOverlay.js";
import {store} from "../../../../Store/index.js";
import {RunInAction_Set} from "web-vcore";
import {AlarmsComp} from "../../../../Engine/LiveSession/Components/AlarmsComp.js";

export const SessionTab = observer_mgl(()=>{
	const uiState = store.main.testing;
	const liveSession = GetLiveSession_Reactive();
	const [ocrCandidateCharValue, setOcrCandidateCharValue] = useState("");
	if (liveSession == null) return <Text>No session is active.</Text>;

	const FindTriggerActivatorByPackageName = (triggerPackageName: string)=>{
		const triggerPackage = liveSession.triggerPackages.find(a=>a.name == triggerPackageName);
		return triggerPackage?.activator;
	};
	const FindTriggerActivatorsWithSequenceWithOneExactSequenceItem = (exactItemData: SequenceItem)=>{
		//const targetJSON = JSON.stringify(exactItemData);
		const excludeNulls = obj=>Object.entries(obj).filter(a=>a[1] != null).ToMapObj(a=>a[0], a=>a[1]);

		return liveSession.triggerPackages.map(a=>a.activator).filter(trigActivator=>{
			return trigActivator?.sequenceActivators.Any(seqActivator=>{
				if (seqActivator.sequence.items.length != 1) return false;
				const item = seqActivator.sequence.items[0];
				//return JSON.stringify(item) == targetJSON;
				return DeepEquals(excludeNulls(item), excludeNulls(exactItemData));
			});
		}) as TriggerSet_Activator[];
	};

	const getPreState = ()=>{
		return {
			inputTime: Date.now(),
			phase: liveSession.Comp(AlarmsComp).phase,
		};
	};
	return (
		<Column>
			<Button text="Switch input-modes" onClick={()=>FindTriggerActivatorByPackageName("Journey_NextInputMode")?.OnSequenceActivated(null, getPreState())}/>
			<Row mt={5}>
				<Text>KeyDown:</Text>
				<Button ml={5} text="VolUp" onClick={()=>FindTriggerActivatorsWithSequenceWithOneExactSequenceItem(new SequenceItem({type: "KeyDown", key_name: "VolumeUp"})).forEach(a=>a.OnSequenceActivated(null, getPreState()))}/>
				<Button ml={5} text="VolDown" onClick={()=>FindTriggerActivatorsWithSequenceWithOneExactSequenceItem(new SequenceItem({type: "KeyDown", key_name: "VolumeDown"})).forEach(a=>a.OnSequenceActivated(null, getPreState()))}/>
			</Row>
			<Row mt={5}>
				<Text>KeyUp:</Text>
				<Button ml={5} text="VolUp" onClick={()=>FindTriggerActivatorsWithSequenceWithOneExactSequenceItem(new SequenceItem({type: "KeyUp", key_name: "VolumeUp"})).forEach(a=>a.OnSequenceActivated(null, getPreState()))}/>
				<Button ml={5} text="VolDown" onClick={()=>FindTriggerActivatorsWithSequenceWithOneExactSequenceItem(new SequenceItem({type: "KeyUp", key_name: "VolumeDown"})).forEach(a=>a.OnSequenceActivated(null, getPreState()))}/>
			</Row>
			<Row mt={5}>
				<Text>Press:</Text>
				<Button ml={5} text="VolUp" onClick={()=>FindTriggerActivatorsWithSequenceWithOneExactSequenceItem(new SequenceItem({type: "Key", key_name: "VolumeUp"})).forEach(a=>a.OnSequenceActivated(null, getPreState()))}/>
				<Button ml={5} text="VolDown" onClick={()=>FindTriggerActivatorsWithSequenceWithOneExactSequenceItem(new SequenceItem({type: "Key", key_name: "VolumeDown"})).forEach(a=>a.OnSequenceActivated(null, getPreState()))}/>
			</Row>
			<Row mt={5}>
				<Text>Hold:</Text>
				<Button ml={5} text="VolUp" onClick={()=>FindTriggerActivatorsWithSequenceWithOneExactSequenceItem(new SequenceItem({type: "KeyHold", key_name: "VolumeUp"})).forEach(a=>a.OnSequenceActivated(null, getPreState()))}/>
				<Button ml={5} text="VolDown" onClick={()=>FindTriggerActivatorsWithSequenceWithOneExactSequenceItem(new SequenceItem({type: "KeyHold", key_name: "VolumeDown"})).forEach(a=>a.OnSequenceActivated(null, getPreState()))}/>
			</Row>
			{/*<Button text="JourneyEntry_HoldUp" onClick={()=>FindTriggerActivator("JourneyEntry_HoldUp").OnSequenceActivated(null)}/>
			<Button text="JourneyEntry_HoldDown" onClick={()=>FindTriggerActivator("JourneyEntry_HoldDown").OnSequenceActivated(null)}/>*/}
			<Row mt={5}>
				<TextInput instant value={ocrCandidateCharValue} onChange={val=>setOcrCandidateCharValue(val.slice(-1))}/>
				<Button ml={5} text="Submit as OCR character" onClick={()=>CanvasOverlay_OnDoubleClick(ocrCandidateCharValue)}/>
			</Row>
			<Row mt={5}>
				<CheckBox text="Override breath-data, interval:" value={uiState.overrideBreathData} onChange={val=>RunInAction_Set(()=>uiState.overrideBreathData = val)}/>
				<Spinner ml={5} min={0.5} step={0.5} value={uiState.overrideBreathData_breathInterval} onChange={val=>RunInAction_Set(()=>uiState.overrideBreathData_breathInterval = val)}/>
				<Text>s</Text>
			</Row>
			<Row mt={5}>
				<CheckBox text="Allow early breath-interval effects" value={uiState.allowEarlyBreathIntervalEffects} onChange={val=>RunInAction_Set(()=>uiState.allowEarlyBreathIntervalEffects = val)}/>
			</Row>
		</Column>
	);
});